import { render, staticRenderFns } from "./support_ticket.html?vue&type=template&id=773a4704&scoped=true&"
import script from "./support_ticket.vue?vue&type=script&lang=js&"
export * from "./support_ticket.vue?vue&type=script&lang=js&"
import style0 from "./support_ticket.vue?vue&type=style&index=0&id=773a4704&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773a4704",
  null
  
)

export default component.exports